import { CellProps } from 'react-table';
import { FormattedDateTimeDisplay } from './FormattedDateTimeDisplay';

export default function DateTimeCellTest(props: CellProps<[]>) {
  return <FormattedDateTimeDisplay dateTime={props.value} />;
}
